import { render, staticRenderFns } from "./permissionsView.vue?vue&type=template&id=db6fb272&scoped=true&"
import script from "./permissionsView.vue?vue&type=script&lang=js&"
export * from "./permissionsView.vue?vue&type=script&lang=js&"
import style0 from "./permissionsView.vue?vue&type=style&index=0&id=db6fb272&prod&lang=scss&scoped=true&"
import style1 from "./permissionsView.vue?vue&type=style&index=1&id=db6fb272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6fb272",
  null
  
)

export default component.exports